export default __webpack_public_path__ + "static/media/d3.86ddffca.svg";